import { SxProps, Theme } from '@mui/material';

const cancelBtn = {
  marginRight: 2,
};

const stickySidebar = {
  position: 'sticky',
  top: '90px',
};

const userContainer: SxProps<Theme> = {
  padding: 2,
  marginY: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexDirection: {
    xs: 'column',
    sm: 'row',
  },
};

const userTextsAlign: SxProps<Theme> = {
  textAlign: {
    xs: 'center',
    sm: 'left',
  },
};

const containerBox: SxProps<Theme> = {
  padding: 2,
  display: 'flex',
  flexDirection: 'column',
};

const PrioritiesContainer: SxProps<Theme> = {
  padding: 2,
  marginY: 2,
};

const feedbackText: SxProps<Theme> = (theme) => ({
  marginLeft: 1,
  color: theme.palette.auxGreen.main,
  fontWeight: 600,
});

const errorText: SxProps<Theme> = (theme) => ({
  marginLeft: 1,
  color: theme.palette.auxRed.main,
  fontWeight: 600,
});

const prioritySubtitle = {
  marginBottom: 2,
  fontWeight: 500,
};

export default {
  cancelBtn,
  stickySidebar,
  feedbackText,
  errorText,
  userTextsAlign,
  userContainer,
  containerBox,
  PrioritiesContainer,
  prioritySubtitle,
};
